module.exports = __webpack_public_path__ + "img/social-twitter.2f85e6a.svg";